import { useEffect, useState } from "react";
import { applyAccent, applyTheme, prefersDark } from "./theme";
import { CraigFace } from "./components/CraigFace";

/**
 * The client's way back in, from a "one quick question" email.
 *
 * Exchanges the signed link for their case and hands them to their
 * practice's page with the conversation restored. Works on whatever device
 * they opened the email on — the phone in their hand, not the laptop they
 * originally used, which is the whole reason this isn't just a bookmark.
 */
export function Resume({ caseId, token }: { caseId: string; token: string }) {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const theme = prefersDark() ? "dark" : "light";
    applyTheme(theme);
    applyAccent(undefined, theme);

    fetch(`/api/cases/${caseId}/resume?k=${encodeURIComponent(token)}`)
      .then(async (r) => {
        const body = await r.json();
        if (!r.ok) throw new Error(body.error);
        return body as { caseId: string; slug: string };
      })
      .then(({ caseId: id, slug }) => {
        localStorage.setItem(`craig:case:${slug}`, id);
        // replace, not assign — the token shouldn't sit in their history.
        window.location.replace(`/${slug}`);
      })
      .catch((e: Error) => setError(e.message));
  }, [caseId, token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      {error ? (
        <div className="card px-5 py-4" style={{ maxWidth: 380 }}>
          <p style={{ fontWeight: 650 }}>We couldn't open that link</p>
          <p style={{ fontSize: 13.5, color: "var(--ink-2)", marginTop: 6 }}>{error}</p>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-3">
          <CraigFace size={44} thinking />
          <span style={{ fontSize: 14, color: "var(--ink-3)" }}>Finding where you left off…</span>
        </div>
      )}
    </div>
  );
}
